import React from 'react';
import UrlScanInProgressListItem from './UrlScanInProgressListItem'
import UrlScanErrorListItem from './UrlScanErrorListItem'
import UrlScanCompleteListItem from './UrlScanCompleteListItem'

function getCompletedScan(link, completedScans){
    // The prop passed into this component should only 
    // include completedScans where hasCompletedScan is true,
    // adding to filter for clarity
    return completedScans.find(completedScan=> completedScan.hasCompletedScan && completedScan.url && (completedScan.url === link.href));
}
function mapListItems(links, completedScans){
    return links.map((link, index) => {
        const completedScan = getCompletedScan(link, completedScans);
        if(completedScan){
            if(completedScan.errorMessage){
                //Completed with error
                return <UrlScanErrorListItem key={index} link={link} errorMessage={completedScan.errorMessage}/>
            }
            else{
                // Completed Successfully
                return <UrlScanCompleteListItem key={index} link={link} completedScan={completedScan} idx={index}/>
            }
        }
        else{
            // Result has not completed
            return <UrlScanInProgressListItem key={index} link={link} />
        }
    });
}

export default function UrlList(props) {
    const { links, completedScans } = props;
    if(links.length === 0){
        return (
            <div className="font-weight-bold">No urls found for scanning</div>
        )
    }
    else{
        return (
            <ul className="list-group list-group-flush">
                {mapListItems(links, completedScans)}
            </ul>
        );
    }
}